// components/EditSolicitudModal.jsx
import { Modal, Button, Form } from "react-bootstrap";

export default function EditSolicitudModal({
                                               open,                    // bool
                                               onClose,                 // () => void
                                               onSave,                  // () => void
                                               data,                    // objeto editData
                                               errors = {},             // objeto editErrors
                                               onChangeField,           // (name, value) => void
                                               onBlurNombre,            // () => void   (tu validateEditNombre)
                                               onBlurRFC,               // () => void   (tu validateEditRFC)
                                               disableSave = false,     // bool (isRFCDuplicateEdit || isBlacklistedEdit)
                                               size = "lg",
                                               style = { zIndex: 11000 },
                                           }) {
    const field = (name) => ({
        value: data?.[name] ?? "",
        onChange: (e) => onChangeField?.(name, e.target.value),
    });

    return (
        <Modal show={open} onHide={onClose} centered size={size} style={style}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Solicitud</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Email (usuario)</Form.Label>
                        <Form.Control type="email" {...field("usuario")} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            {...field("nombre_usuario")}
                            onBlur={onBlurNombre}
                            isInvalid={!!errors.nombre}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.nombre}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Apellido Paterno</Form.Label>
                        <Form.Control
                            {...field("apellido_paterno")}
                            onBlur={onBlurNombre}
                            isInvalid={!!errors.nombre}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.nombre}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Apellido Materno</Form.Label>
                        <Form.Control
                            {...field("apellido_materno")}
                            onBlur={onBlurNombre}
                            isInvalid={!!errors.nombre}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.nombre}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>RFC</Form.Label>
                        <Form.Control
                            {...field("rfc")}
                            onChange={(e) => onChangeField?.("rfc", e.target.value.toUpperCase())}
                            onBlur={onBlurRFC}
                            isInvalid={!!errors.rfc}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.rfc}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Número Empleado</Form.Label>
                        <Form.Control {...field("numero_vendedor")} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control {...field("telefono")} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Supervisor Distribuidor</Form.Label>
                        <Form.Control type="text" {...field("supervisor_distribuidor")} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>RFC Supervisor Distribuidor</Form.Label>
                        <Form.Control type="text" {...field("rfc_supervisor_distribuidor")} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Clave Supervisor</Form.Label>
                        <Form.Control type="text" {...field("clave_supervisor")} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancelar</Button>
                <Button variant="primary" onClick={onSave} disabled={disableSave}>
                    Guardar Cambios
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
